import { render, staticRenderFns } from "./DepartManage.vue?vue&type=template&id=6479e915&scoped=true&"
import script from "./DepartManage.vue?vue&type=script&lang=js&"
export * from "./DepartManage.vue?vue&type=script&lang=js&"
import style0 from "./DepartManage.vue?vue&type=style&index=0&id=6479e915&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479e915",
  null
  
)

export default component.exports